const MAILBOX_T = {
    form_name: "Name",
    form_email: "Email (optional)",
    form_number: "Mobile Number (optional)",
    form_subject: "Subject",
    form_message: "Message",
    form_btn: "Send",
    title: "Contact us",
    subTitle_1: "Face-to-face form ",
    text_11: "Street 36 # 31-39 Local 101",
    text_12: "Business center Chicamocha",
    text_13: "Monday to Friday: 07:00 - 12:30pm y 1:00pm -5:00pm",
    text_14: "Bucaramanga, Santander",
    subTitle_2: "From distance",
    text_21: "Mobile: 316 279 5010",
    text_22: "Phone: 680 3596",
    text_23: "curaduriaurbana1@gmail.com",
    text_24: "WhatsApp Chat Online",
    subTitle_3: "Location of the Urban Curatorship N° 1 of Bucaramanga",
    subTitle_4: "Virtual form",
    text_41: "Direct contact form with the Urban Curatorship N° 1 of Bucaramanga",
}

export default MAILBOX_T;